export default __webpack_public_path__ + "static/media/icons8-home.b8d81218.svg";